import { lazy, Suspense } from "react";
import { SkeletonPage } from "@/components/SkeletonLoaders";
import { Navigate } from "react-router-dom";

const FoodLandingPage = lazy(() => import("./pages/FoodLandingPage"));
const FoodListPage = lazy(() => import("./pages/FoodListPage"));
const FoodSubscriptionListPage = lazy(() => import("./pages/FoodSubscriptionListPage"));
const FoodSlotBook = lazy(() => import("./pages/FoodSlotBook"));
const FoodSummary = lazy(() => import("./pages/FoodSummary"));
const FoodThanksPage = lazy(() => import("./pages/FoodThanksPage"));

const foodRoutes = [
    {
        path: "food",
        children: [
            {
                index: true,
                element: <Navigate to="9" replace />,
            },
            {
                path: ":category_id",
                element: (
                    <Suspense fallback={<SkeletonPage />}>
                        <FoodLandingPage />
                    </Suspense>
                ),
            },
            {
                path: ":category_id/list",
                element: (
                    <Suspense fallback={<SkeletonPage />}>
                        <FoodListPage />
                    </Suspense>
                ),
            },
            {
                path: ":category_id/subscriptions",
                element: (
                    <Suspense fallback={<SkeletonPage />}>
                        <FoodSubscriptionListPage />
                    </Suspense>
                ),
            },
            {
                path: ":category_id/slot-book",
                element: (
                    <Suspense fallback={<SkeletonPage />}>
                        <FoodSlotBook />
                    </Suspense>
                ),
            },
            {
                path: ":category_id/summary",
                element: (
                    <Suspense fallback={<SkeletonPage />}>
                        <FoodSummary />
                    </Suspense>
                ),
            },
            {
                path: ":category_id/thanks",
                element: (
                    <Suspense fallback={<SkeletonPage />}>
                        <FoodThanksPage />
                    </Suspense>
                ),
            },
        ],
    },
];

export default foodRoutes;
